import { isServer } from "@qwik.dev/core/build";
const createMacroTask = (e) => {
  let t;
  if (typeof MessageChannel !== "undefined") {
    const n = new MessageChannel();
    n.port1.onmessage = () => e();
    t = () => n.port2.postMessage(null);
  } else t = () => setTimeout(e);
  return t;
};
const hasDocument = typeof document !== "undefined";
const isBrowser = !isServer && hasDocument;
const doc = isBrowser ? document : void 0;
const config = { t: 25 };
const rel = isBrowser && doc.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";
performance.now();
const isJSRegex = /\.[mc]?js$/;
const yieldInterval = 1e3 / 60;
const BundleImportState_None = 0;
const BundleImportState_Queued = 1;
const BundleImportState_Preload = 2;
const BundleImportState_Alias = 3;
const BundleImportState_Loaded = 4;
const bundles = /* @__PURE__ */ new Map();
let queueDirty;
let preloadCount = 0;
const queue = [];
const nextTriggerMacroTask = createMacroTask(trigger);
const nextAdjustmentMacroTask = createMacroTask(processPendingAdjustments);
let isTriggerScheduled = 0;
let isAdjustmentScheduled = 0;
let isProcessingAdjustments = 0;
const adjustmentStack = [];
const sortQueue = () => {
  if (queueDirty) {
    queue.sort((e, t) => e.o - t.o);
    queueDirty = 0;
  }
};
function trigger() {
  isTriggerScheduled = 0;
  if (!queue.length) return;
  sortQueue();
  const e = performance.now() + yieldInterval;
  let t = 0;
  while (queue.length) {
    const n = queue[0];
    const s = n.o;
    const r = 1 - s;
    if (r >= 0.99 || preloadCount < config.t) {
      queue.shift();
      preloadOne(n);
      if (performance.now() >= e) {
        t = 1;
        break;
      }
    } else break;
  }
  if (t && queue.length && !isTriggerScheduled) {
    isTriggerScheduled = 1;
    nextTriggerMacroTask();
  }
}
const enqueueAdjustment = (e, t, n) => {
  adjustmentStack.unshift({ u: e, o: t, i: n });
};
const processAdjustmentFrame = () => {
  const e = adjustmentStack[adjustmentStack.length - 1];
  const t = e.u;
  if (e.l) {
    const n2 = e.m;
    if (n2 >= e.l.length) {
      adjustmentStack.pop();
      return 0;
    }
    const s = e.l[n2];
    e.m = n2 + 1;
    const r = getBundle(s.p);
    if (r.o === 0) return 1;
    const o = 1 - t.o;
    let a;
    if (o === 1 || o >= 0.99) a = Math.min(0.01, 1 - s.S);
    else {
      const e2 = 1 - s.S * o;
      const t2 = s.B;
      const n3 = e2 / t2;
      a = Math.max(0.02, r.o * n3);
      s.B = n3;
    }
    adjustmentStack.push({ u: r, o: a, i: e.i });
    return 1;
  }
  if (e.i?.has(t)) {
    adjustmentStack.pop();
    return 0;
  }
  const n = t.o;
  t.o = e.o;
  if (n - t.o < 0.01) {
    adjustmentStack.pop();
    return 0;
  }
  if (
    // don't queue until we have initialized the preloader
    base != null && t.$ < BundleImportState_Preload
  ) {
    if (t.$ === BundleImportState_None) {
      t.$ = BundleImportState_Queued;
      queue.push(t);
    }
    queueDirty = 1;
  }
  if (t.l?.length) {
    const n2 = e.i || /* @__PURE__ */ new Set();
    n2.add(t);
    e.i = n2;
    e.l = t.l;
    e.m = 0;
    return 0;
  }
  adjustmentStack.pop();
  return 0;
};
function processPendingAdjustments() {
  if (isProcessingAdjustments || !adjustmentStack.length) return;
  isAdjustmentScheduled = 0;
  isProcessingAdjustments = 1;
  const e = isBrowser ? performance.now() + yieldInterval : 0;
  let t = 0;
  while (adjustmentStack.length) {
    t = 1;
    const n = processAdjustmentFrame();
    if (isBrowser && n && performance.now() >= e) {
      if (!isAdjustmentScheduled) {
        isAdjustmentScheduled = 1;
        nextAdjustmentMacroTask();
      }
      break;
    }
  }
  isProcessingAdjustments = 0;
  if (t && isBrowser) nextTriggerMacroTask();
}
const preloadOne = (e) => {
  if (e.$ >= BundleImportState_Preload) return;
  preloadCount++;
  const t = performance.now();
  e.j = t - e.h;
  e.$ = BundleImportState_Preload;
  const n = doc.createElement("link");
  n.href = new URL(`${base}${e.p}`, doc.baseURI).toString();
  n.rel = rel;
  n.as = "script";
  n.onload = n.onerror = () => {
    preloadCount--;
    const s = performance.now();
    e.k = s - t;
    e.$ = BundleImportState_Loaded;
    n.remove();
    nextTriggerMacroTask();
  };
  doc.head.appendChild(n);
};
const adjustProbabilities = (e, t, n) => {
  enqueueAdjustment(e, t, n);
  if (isBrowser) nextAdjustmentMacroTask();
  else processPendingAdjustments();
};
const handleBundle = (e, t) => {
  const n = getBundle(e);
  if (n) enqueueAdjustment(n, t);
};
const preload = (e, t) => {
  if (!e?.length) return;
  const n = t ? 1 - t : 0.4;
  if (Array.isArray(e)) for (let t2 = e.length - 1; t2 >= 0; t2--) {
    const s = e[t2];
    handleBundle(s, n);
  }
  else handleBundle(e, n);
  if (isBrowser) nextAdjustmentMacroTask();
  else processPendingAdjustments();
};
if (isBrowser) document.addEventListener("qsymbol", (e) => {
  const { symbol: t, href: n } = e.detail;
  if (n) {
    const e2 = t.slice(t.lastIndexOf("_") + 1);
    preload(e2, 1);
  }
});
let base;
let graph;
const makeBundle = (e, t) => ({ p: e, $: isJSRegex.test(e) ? BundleImportState_None : BundleImportState_Alias, l: t, o: 1, h: performance.now(), j: 0, k: 0 });
const parseBundleGraph = (e) => {
  const t = /* @__PURE__ */ new Map();
  let n = 0;
  while (n < e.length) {
    const s = e[n++];
    const r = [];
    let o;
    let a = 1;
    while (o = e[n], typeof o === "number") {
      if (o < 0) a = -o / 10;
      else r.push({ p: e[o], S: a, B: 1 });
      n++;
    }
    t.set(s, r);
  }
  return t;
};
const getBundle = (e) => {
  let t = bundles.get(e);
  if (!t) {
    let n;
    if (graph) {
      n = graph.get(e);
      if (!n) return;
      if (!n.length) n = void 0;
    }
    t = makeBundle(e, n);
    bundles.set(e, t);
  }
  return t;
};
const loadBundleGraph = (e, t, n) => {
  if (n) {
    if ("P" in n) config.t = n["P"];
  }
  if (!isBrowser || e == null) return;
  base = e;
  if (t) t.then((e2) => e2.text()).then((e2) => {
    graph = parseBundleGraph(JSON.parse(e2));
    const t2 = [];
    for (const [e3, n3] of graph.entries()) {
      const s2 = getBundle(e3);
      s2.l = n3;
      if (s2.o < 1) {
        t2.push([s2, s2.o]);
        s2.o = 1;
      }
    }
    if (!t2.length) {
      nextTriggerMacroTask();
      return;
    }
    let n2 = 0;
    const s = createMacroTask(() => {
      const e3 = performance.now() + yieldInterval;
      while (n2 < t2.length) {
        const [r, o] = t2[n2];
        n2++;
        adjustProbabilities(r, o);
        if (n2 < t2.length && performance.now() >= e3) {
          s();
          return;
        }
      }
      nextTriggerMacroTask();
    });
    s();
  }).catch(console.warn);
};
export {
  parseBundleGraph as g,
  loadBundleGraph as l,
  preload as p
};
